<template>
  <AllegroJsonForm
    title="Allegro - Edycja konta"
    crumbLabel="Edycja konta"
    :accountCrumb="true"
    submitAction="updateAllegroAccount"
    submitGetter="getAllegroAccountUpdateData"
    loadAction="getAllegroAccount"
    loadGetter="getAllegroAccountData"
    :isUpdate="true"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroAccountPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroAccountUpdate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroAccountPermissionsConst.update,
      fields: [
        { key: "name", label: "Nazwa konta", required: true },
        { key: "email", label: "E-mail", type: "email", required: true },
      ],
    };
  },
};
</script>
